/*
 * @Author: Hancle
 * @Date: 2019-07-23 17:40:43
 * @Last Modified by: Hancle
 * @Last Modified time: 2019-07-27 10:59:56
 */
const state = {
  // 播放中的音频id
  playingId: "0",
  // 是否正在播放
  isplaying: false,
  // 播放中的音频
  playingAudio: {},
  // 音频列表
  audios: [],
  // 当前播放时间，单位：秒
  currentTime: "0",
  // 拖动播放的时间
  seekTime: "0"
};

const mutations = {
  SET_PLAYING_AUDIO(state, audio) {
    state.playingAudio = audio;
  },
  SET_AUDIOS(state, audios) {
    state.audios = audios;
  },
  SET_IS_PLAYING(state, isplaying) {
    // console.log('SET_IS_PLAYING', isplaying)
    state.isplaying = isplaying;
  },
  SET_PLAYING_ID(state, audioId) {
    state.playingId = audioId;
  },
  SET_CURRENT_TIME(state, second) {
    state.currentTime = second;
  },
  SET_SEEK_TIME(state, second) {
    console.log("SET_SEEK_TIME", second);
    state.seekTime = second;
  }
};

const actions = {
  setPlayingAudio({ commit }, audio) {
    if (audio && audio.id) commit("SET_PLAYING_ID", audio.id);
    commit("SET_PLAYING_AUDIO", audio);
  },
  setAudios({ commit }, audios) {
    commit("SET_AUDIOS", audios);
  },
  setIsPlaying({ commit }, isplaying) {
    commit("SET_IS_PLAYING", isplaying);
  },
  setPlayingId({ commit }, audioId) {
    commit("SET_PLAYING_ID", audioId);
  },
  setPlay({ commit }, audio) {
    // console.log('setPlay :', audio);
    if (audio && audio.id) commit("SET_PLAYING_ID", audio.id);
    commit("SET_PLAYING_AUDIO", audio);
    commit("SET_IS_PLAYING", false);
    commit("SET_IS_PLAYING", true);
  },
  setCurrentTime({ commit }, second) {
    // console.log("setCurrentTime");
    if (second >= 0) {
      commit("SET_CURRENT_TIME", second);
    }
  },
  setSeekTime({ commit }, second) {
    commit("SET_SEEK_TIME", second);
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/globalAudio.js